"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Filter = void 0;
const ConstantFilter_1 = require("./ConstantFilter");
const IntersectionFilter_1 = require("./IntersectionFilter");
const UnionFilter_1 = require("./UnionFilter");
const ComplementFilter_1 = require("./ComplementFilter");
const PatientByHcPartyAndActiveFilter_1 = require("./PatientByHcPartyAndActiveFilter");
const PatientByHcPartyAndExternalIdFilter_1 = require("./PatientByHcPartyAndExternalIdFilter");
const PatientByHcPartyAndSsinsFilter_1 = require("./PatientByHcPartyAndSsinsFilter");
const PatientByHcPartyDateOfBirthBetweenFilter_1 = require("./PatientByHcPartyDateOfBirthBetweenFilter");
const PatientByHcPartyDateOfBirthFilter_1 = require("./PatientByHcPartyDateOfBirthFilter");
const date_fns_1 = require("date-fns");
const PatientByHcPartyFilter_1 = require("./PatientByHcPartyFilter");
const PatientByHcPartyGenderEducationProfession_1 = require("./PatientByHcPartyGenderEducationProfession");
const PatientByIdsFilter_1 = require("./PatientByIdsFilter");
const PatientByHcPartyNameContainsFuzzyFilter_1 = require("./PatientByHcPartyNameContainsFuzzyFilter");
__exportStar(require("./PatientByHcPartyAndActiveFilter"), exports);
__exportStar(require("./PatientByHcPartyAndExternalIdFilter"), exports);
__exportStar(require("./PatientByHcPartyAndSsinsFilter"), exports);
__exportStar(require("./PatientByHcPartyDateOfBirthBetweenFilter"), exports);
__exportStar(require("./PatientByHcPartyDateOfBirthFilter"), exports);
__exportStar(require("./PatientByHcPartyFilter"), exports);
__exportStar(require("./PatientByHcPartyGenderEducationProfession"), exports);
__exportStar(require("./PatientByHcPartyNameContainsFuzzyFilter"), exports);
__exportStar(require("./PatientByHcPartyNameFilter"), exports);
__exportStar(require("./PatientByIdsFilter"), exports);
class Filter {
    static patient() {
        return new PatientFilterBuilder();
    }
}
exports.Filter = Filter;
class FilterBuilder {
    constructor(filterProvider, composer) {
        this.composer = (thisFilterBuilder, otherFilterBuilder) => otherFilterBuilder;
        this.filterProvider = filterProvider;
        composer && (this.composer = composer);
    }
    listOf(elements) {
        return this.clone(() => new ConstantFilter_1.ConstantFilter(elements));
    }
    makeLazyLeftRightFilterBuilder(leftHandRightHandFiltersCombiner) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const leftHandFilterBuilder = this;
        return leftHandFilterBuilder.filterProvider
            ? this.clone(undefined, //filter provider is indeterminate until we have performed a composition
            (orFilterBuilder, rightHandFilterBuilder) => {
                const leftHandFilter = leftHandFilterBuilder.build();
                const rightHandFilter = rightHandFilterBuilder.build();
                return rightHandFilter
                    ? this.clone(leftHandRightHandFiltersCombiner(leftHandFilter, rightHandFilter), rightHandFilterBuilder.composer)
                    : rightHandFilterBuilder;
            })
            : this;
    }
    makeEagerLeftRightFilterBuilder(rightHandFilterBuilderFactory, leftHandRightHandFiltersCombiner) {
        const rightHandFilterBuilder = rightHandFilterBuilderFactory(this);
        return this.filterProvider ? this.clone(leftHandRightHandFiltersCombiner(this.build(), rightHandFilterBuilder.build())) : this;
    }
    and(filterBuilderFactory) {
        const combiner = (leftHandFilter, rightHandFilter) => () => new IntersectionFilter_1.IntersectionFilter([leftHandFilter, rightHandFilter]);
        return filterBuilderFactory ? this.makeEagerLeftRightFilterBuilder(filterBuilderFactory, combiner) : this.makeLazyLeftRightFilterBuilder(combiner);
    }
    or(filterBuilderFactory) {
        const combiner = (leftHandFilter, rightHandFilter) => () => new UnionFilter_1.UnionFilter([leftHandFilter, rightHandFilter]);
        return filterBuilderFactory ? this.makeEagerLeftRightFilterBuilder(filterBuilderFactory, combiner) : this.makeLazyLeftRightFilterBuilder(combiner);
    }
    minus(filterBuilderFactory) {
        const combiner = (leftHandFilter, rightHandFilter) => () => new ComplementFilter_1.ComplementFilter(leftHandFilter, rightHandFilter);
        return filterBuilderFactory ? this.makeEagerLeftRightFilterBuilder(filterBuilderFactory, combiner) : this.makeLazyLeftRightFilterBuilder(combiner);
    }
}
class PatientFilterBuilder extends FilterBuilder {
    constructor(filterProvider, hcpId, composer) {
        super(filterProvider, composer);
        this.hcpId = hcpId;
    }
    clone(filterProvider, composer) {
        return new PatientFilterBuilder(filterProvider, this.hcpId, composer);
    }
    listOf(elements) {
        return new PatientFilterBuilder(() => new ConstantFilter_1.ConstantFilter(elements));
    }
    and(filterBuilderFactory) {
        return super.and(filterBuilderFactory);
    }
    or(filterBuilderFactory) {
        return super.or(filterBuilderFactory);
    }
    minus(filterBuilderFactory) {
        return super.minus(filterBuilderFactory);
    }
    forHcp(hcpId) {
        return this.composer(this, new PatientFilterBuilder(this.filterProvider, hcpId));
    }
    all() {
        return this.composer(this, new PatientFilterBuilder(() => new PatientByHcPartyFilter_1.PatientByHcPartyFilter({ healthcarePartyId: this.hcpId }), this.hcpId));
    }
    activePatients() {
        return this.composer(this, new PatientFilterBuilder(() => new PatientByHcPartyAndActiveFilter_1.PatientByHcPartyAndActiveFilter({ healthcarePartyId: this.hcpId, active: true }), this.hcpId));
    }
    inactivePatients() {
        return this.composer(this, new PatientFilterBuilder(() => new PatientByHcPartyAndActiveFilter_1.PatientByHcPartyAndActiveFilter({ healthcarePartyId: this.hcpId, active: false }), this.hcpId));
    }
    withExternalId(externalId) {
        return this.composer(this, new PatientFilterBuilder(() => new PatientByHcPartyAndExternalIdFilter_1.PatientByHcPartyAndExternalIdFilter({
            healthcarePartyId: this.hcpId,
            externalId: externalId,
        }), this.hcpId));
    }
    withSsins(ssins) {
        return this.composer(this, new PatientFilterBuilder(() => new PatientByHcPartyAndSsinsFilter_1.PatientByHcPartyAndSsinsFilter({ healthcarePartyId: this.hcpId, ssins: ssins }), this.hcpId));
    }
    withDateOfBirthBetween(from, to) {
        return this.composer(this, this.clone(() => new PatientByHcPartyDateOfBirthBetweenFilter_1.PatientByHcPartyDateOfBirthBetweenFilter({
            healthcarePartyId: this.hcpId,
            minDateOfBirth: from,
            maxDateOfBirth: to,
        })));
    }
    byDateOfBirth(dateOfBirth) {
        return this.composer(this, new PatientFilterBuilder(() => new PatientByHcPartyDateOfBirthFilter_1.PatientByHcPartyDateOfBirthFilter({
            healthcarePartyId: this.hcpId,
            dateOfBirth: dateOfBirth,
        }), this.hcpId));
    }
    olderThan(age) {
        return this.withDateOfBirthBetween(10000101, parseInt(date_fns_1.format(date_fns_1.add(new Date(), { years: -age }), 'yyyyMMdd')));
    }
    youngerThan(age) {
        return this.withDateOfBirthBetween(parseInt(date_fns_1.format(date_fns_1.add(new Date(), { years: -age }), 'yyyyMMdd')), 99991231);
    }
    byGenderEducationProfession(gender, education, profession) {
        return this.composer(this, new PatientFilterBuilder(() => new PatientByHcPartyGenderEducationProfession_1.PatientByHcPartyGenderEducationProfession({
            healthcarePartyId: this.hcpId,
            gender: gender,
            education: education,
            profession: profession,
        }), this.hcpId));
    }
    byIds(ids) {
        return this.composer(this, new PatientFilterBuilder(() => new PatientByIdsFilter_1.PatientByIdsFilter({ ids: ids }), this.hcpId));
    }
    searchByName(name) {
        return this.composer(this, new PatientFilterBuilder(() => new PatientByHcPartyNameContainsFuzzyFilter_1.PatientByHcPartyNameContainsFuzzyFilter({
            healthcarePartyId: this.hcpId,
            searchString: name,
        }), this.hcpId));
    }
    build() {
        var _a;
        return ((_a = this.filterProvider) === null || _a === void 0 ? void 0 : _a.call(this)) || this.all().build();
    }
}
//# sourceMappingURL=filters.js.map